import {Map} from 'immutable';

import {ImageV2} from './ImageV2.react';

export default Map({
  renderer: ImageV2,
  type: 'image',
  label: 'Image',
  hidePreviewToggle: true
});
